module.exports = __webpack_public_path__ + "img/image02_sp.55064115.jpg";